"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterOperation = exports.useFilters = void 0;
const react_1 = require("react");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const common_types_1 = require("../../common/common-types");
function useFilters({ source, filtersFields, preFilters, }) {
    /**
     * Inner state of filter form.
     */
    const [filters, setFilters] = react_1.useState(() => {
        var _a, _b;
        const defaultFilters = (_b = (_a = source.getParams()) === null || _a === void 0 ? void 0 : _a.filters) !== null && _b !== void 0 ? _b : [];
        const initState = filtersFields.map((f) => {
            var _a, _b;
            const defaultFilter = defaultFilters === null || defaultFilters === void 0 ? void 0 : defaultFilters.find((filter) => filter.field === f.filterkey);
            return {
                field: f.filterkey,
                operation: (_b = (_a = defaultFilter === null || defaultFilter === void 0 ? void 0 : defaultFilter.operation) !== null && _a !== void 0 ? _a : f.defaultOperation) !== null && _b !== void 0 ? _b : common_types_1.ApiFilterOperation.CONTAINS,
                asciiFolding: false,
                value: defaultFilter === null || defaultFilter === void 0 ? void 0 : defaultFilter.value,
            };
        });
        return initState;
    });
    const validFilters = react_1.useMemo(() => filters
        .filter((f) => !!f.value)
        .map((f) => ({
        field: f.field,
        operation: f.operation,
        visible: f.visible,
        asciiFolding: f.asciiFolding,
        value: f.value,
    })), [filters]);
    /**
     * Reset filters and source into init state.
     */
    const reset = event_callback_hook_1.useEventCallback(() => {
        setFilters(filtersFields.map((f) => {
            var _a;
            return ({
                field: f.filterkey,
                operation: (_a = f.defaultOperation) !== null && _a !== void 0 ? _a : common_types_1.ApiFilterOperation.CONTAINS,
            });
        }));
        source.setParams({ filters: [...preFilters] });
        source.reset();
        source.loadMore();
    });
    /**
     * Changes the value of the filter.
     */
    const handleFilterValueChange = event_callback_hook_1.useEventCallback((index, value) => {
        setFilters((filters) => [
            ...filters.slice(0, index),
            { ...filters[index], visible: true, value },
            ...filters.slice(index + 1),
        ]);
    });
    /**
     * Changes the state of the filter.
     */
    const handleFilterStateChange = event_callback_hook_1.useEventCallback((index, state) => {
        setFilters((filters) => [
            ...filters.slice(0, index),
            state,
            ...filters.slice(index + 1),
        ]);
    });
    /**
     * Sets params to source.
     */
    const search = event_callback_hook_1.useEventCallback(() => {
        const params = source.getParams();
        source.setParams({ ...params, filters: [...validFilters, ...preFilters] });
        source.reset();
        source.loadMore();
    });
    return {
        filters,
        reset,
        handleFilterValueChange,
        handleFilterStateChange,
        search,
        validFilters,
    };
}
exports.useFilters = useFilters;
function useFilterOperation(state, onChangeState) {
    const handleChangeOperation = event_callback_hook_1.useEventCallback((operation) => {
        if (operation) {
            onChangeState({
                ...state,
                operation: operation,
            });
        }
    });
    return { handleChangeOperation };
}
exports.useFilterOperation = useFilterOperation;
//# sourceMappingURL=field-filter-hook.js.map